import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { TableSkeleton } from '../../components/TableSkeleton';
import { buildDriverColumns } from './build-driver-columns';
import { CreateDriverDrawer } from './CreateDriverDrawer';
import { DriversTable } from './DriversTable';
import { useDrivers } from './use-drivers';
import { sectionTrail } from '../../layouts/section-trail';

export function DriversPage() {
  const { state, list, isRefreshing, createError, creating, create, resetCreateError } = useDrivers();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildDriverColumns({ list });

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('drivers')}
        title="Drivers"
        description="The people who drive for you — profiles, licences and compliance documents."
        actions={
          <Button
            type="primary"
            icon={<Plus className="size-4" />}
            onClick={() => {
              resetCreateError();
              setDrawerOpen(true);
            }}
          >
            Create driver
          </Button>
        }
      />
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load drivers" description="Something went wrong loading the drivers list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading drivers" withSearch />}
      {state.status === 'loaded' && <DriversTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateDriverDrawer open={drawerOpen} error={createError} submitting={creating} onCreate={create} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
